import React from "react";

interface BoldProps {
  component: React.JSX.Element;
}

const Bold = ({ component }: BoldProps) => (
  <span style={{ fontWeight: "bold" }}>{component}</span>
);
export default Bold;
